import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';
import { get } from 'lodash';
import { message } from 'antd';
import * as types from './types';
import * as actions from './actions';
import * as api from '@api/changeLog';

const displayError = (err) => {
  const error = get(err, 'response.data.message', 'Unknown Error');
  message.error(error);
}

function* init(action) {
  try {
    yield put(actions.toggleLoading(true))
    const resp = yield call(api.getLogs, action.logType);
    const { data } = resp;
    yield put(actions.setLogs(data));
  } catch (err) {
    displayError(err);
  } finally {
    yield put(actions.toggleLoading(false));
  }
}

function* fetch(action) {
  try {
    const resp = yield call(api.getLog, action.id);
    const { data } = resp;
    yield put(actions.setDetail(data));
    yield put(actions.toggleDetail(true));
  } catch (err) {
    displayError(err);
  }
}

const watchMap = {
  [types.INIT]: init,
  [types.FETCH_DETAIL]: fetch,
}
function* watch() {
  for (const [type, func] of Object.entries(watchMap)) {
    yield takeLatest([type], func);
  }
}

export default [
  watch,
];
